import axios from 'axios';

const isStateMatchPostcode = (state: string, [postcode]: [any]) => {
    return {
        valid: true,
        data: "skip"
    };
    let dataString = 'state=' + state + '&postcode=' + postcode;
    return axios
        .get('https://pcmiler.alk.com/apis/rest/v1.0/Service.svc/locations?' + dataString, {
            headers: { authorization: '9A4DC5EC2EFCEA4C8917545360589148' },
        })
        .then(response => {
            // Notice that we return an object containing both a valid property and a data property.
            return {
                valid:
                    response.data[0].Address &&
                    (response.data[0].Address.State === state ||
                        response.data[0].Address.StateName === state),
                data: {
                    message: 'The state does not match the postcode',
                },
            };
        });
};

export default isStateMatchPostcode;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/validation/validateLocation/isStateMatchPostcode.ts